var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-xs":"","id":"your-account-container"}},[_c('div',{attrs:{"id":"your-account-navigation"}},[_vm._v("\n      asdasd\n    ")]),_c('div',{attrs:{"id":"your-account-content"}})])}
var staticRenderFns = []

export { render, staticRenderFns }